import { SxProps, Theme } from "@mui/material/styles";
import theme, { gris3, gris4 } from "../../theme";

const styles: SxProps<Theme> = [
  {
    "&.layout": {
      margin: "auto",
      minHeight: "calc(100vh - 11.625rem)",
      "& > div, & > form": {
        paddingLeft: "68px",
        paddingRight: "68px",
      },
      "& > div": {
        marginTop: "58px",
      },
      "& .bigTitle": {
        marginTop: 0,
        background: theme.palette.primary.main,
        padding: "158px 12px 32px 12px",
        color: "#FFF",
        fontWeight: "bold",
      },
      "&.full": {
        maxWidth: "100%",
        padding: 0,
        "& > div, & > form": {
          paddingLeft: "0",
          paddingRight: "0",
          marginTop: "inherit",
        },
      },
      "& blockquote": {
        margin: 0,
        marginTop: "0.75rem",
        fontStyle: "italic",
      },
      "& ul": {
        margin: 0,
        padding: 0,
      },
      "& li": {
        listStyle: "none",
      },
      "& .fondGris": {
        backgroundColor: gris4,
      },
      "& .fondGrisFonce": {
        backgroundColor: gris3,
      },
      "& .inputForm": {
        margin: "10px",
      },
      "& .acc-hidden-title": {
        position: "absolute",
        left: "-9999px",
      },
      "& .textUppercase": {
        textTransform: "uppercase",
      },
      "& .textAlignCenter": {
        textAlign: "center",
      },
      "& .noMargin": {
        margin: 0,
      },
      "& .marginTop24": {
        marginTop: "24px",
      },
      "& h3": {
        textTransform: "uppercase",
        margin: "0 0 12px 0",
        fontSize: 15,
      },
      "& .boxShadow": {
        boxShadow:
          " 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)",
      },
      "& .defaultLink": {
        marginLeft: "4px",
        textDecoration: "underline",
        marginBottom: "12px",
      },
      "& button": {
        fontFamily: "Montserrat, sans-serif",
      },
      "& .capitalize": {
        textTransform: "capitalize",
      },
      "& .titlePage": {
        margin: 0,
        marginBottom: "12px",
        textTransform: "uppercase",
        paddingLeft: "68px",
        paddingRight: "68px",
      },
      "& .backLink": {
        display: "flex",
        alignItems: "center",
        marginBottom: "8px",
      },
      "& .cancelLink": {
        color: "#000",
        marginTop: "16px",
      },
    },
  },
];

export default styles;
